import { getEmailCounts } from 'api/system'
import { hasStoredToken } from 'store/auth'
import { isAdmin } from 'store/profile'

const POLL_INTERVAL_MS = 60000

const counts = flyd.stream({ failed: 0, unread: 0 })
let pollTimer = null

export const emailCounts = () => {
  return counts()
}

export const refreshEmailCounts = () => {
  if (!hasStoredToken() || !isAdmin()) {
    return Promise.resolve()
  }
  return getEmailCounts().then(data => {
    if (data) {
      counts(data)
    }
  })
}

export const startEmailCountsPolling = () => {
  if (pollTimer) {
    return
  }
  refreshEmailCounts()
  pollTimer = setInterval(refreshEmailCounts, POLL_INTERVAL_MS)
}
